module.exports = __webpack_public_path__ + "static/img/cyberpunk_gif.07e2a5e.gif";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/home/cyberpunk_gif.gif
// module id = 6cZi
// module chunks = 1